document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const header = document.querySelector('[data-site-header]');

  if (toggle && drawer) {
    toggle.addEventListener('click', () => {
      const open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      if (header) document.documentElement.style.setProperty('--mobile-header-top', `${header.getBoundingClientRect().bottom}px`);
    });
  }

  document.querySelectorAll('[data-nav-item]').forEach(item => {
    const link = item.querySelector('.nav-link[aria-haspopup="true"]');
    if (!link) return;
    item.addEventListener('mouseenter', () => link.setAttribute('aria-expanded', 'true'));
    item.addEventListener('mouseleave', () => link.setAttribute('aria-expanded', 'false'));
    item.addEventListener('focusin', () => link.setAttribute('aria-expanded', 'true'));
    item.addEventListener('focusout', e => {
      if (!item.contains(e.relatedTarget)) link.setAttribute('aria-expanded', 'false');
    });
  });
});
